<template>
  <div>
    <Navbar></Navbar>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <div class="content">
            <form @submit.prevent="editSpecialtyMeth">
              <div class="content-body">
                <form @submit.prevent="editSpecialtyMeth">
                  <div class="header">
                    <h5 class="title is-5" v-if="getEditingSpecialty">
                      {{ $t('SpecialtyData.PleaseModifySpecialtyData') }}
                    </h5>
                    <h5 class="title is-5" v-if="!getEditingSpecialty">
                      {{ $t('SpecialtyData.SpecialtyData') }}
                    </h5>
                  </div>
                  <div class="columns">
                    <div class="column is-half">
                      <div class="field">
                        <label class="label">{{ $t('SpecialtyData.Name') }}</label>
                        <div class="control">
                          <input :minlength='2' v-model="getEditedSpecialtyData.name" class="input" type="text"
                          :placeholder="$t('SpecialtyData.NamePlaceholder')" required :disabled="!getEditingSpecialty">
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <!-- List of files -->
              <div class="content-body" v-if="!addingFile">
                <label class="label mt-4">{{ $t('FilesData.Files') }}</label>
                <div class="table-container mb-2">
                  <table class="table" :key="getEditedSpecialtyData.specialty_id">
                    <thead>
                      <tr>
                        <th class="">{{ $t('FilesData.FileContent') }}</th>
                        <th class="">{{ $t('FilesData.FileType') }}</th>
                        <th class="" v-if="getAccessType != 'customer'">{{ $t('FilesData.FileSize') }}</th>
                        <th class="" v-if="getAccessType != 'customer'">{{ $t('FilesData.FileUploadTime') }}</th>
                        <th class="sticky-column">{{ $t('FilesData.OpenContent') }}</th>
                        <th v-if="getEditingSpecialty">{{ $t('General.Operations') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="file of getEditedSpecialtyFiles" :key="getEditedSpecialtyData.specialty_id + '-' + file.file_id + '-' + file.pos">
                        <SpecialtyDataFileTableRow
                          :file-data="file"
                          :key="getEditedSpecialtyData.specialty_id + '-' + file.file_id + '-' + file.pos">
                        </SpecialtyDataFileTableRow>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Button to add new file -->
              <div class="content-body">
                <div class="header is-flex is-justify-content-space-between" v-if="!addingFile && getEditingSpecialty">
                  <div>
                    <button class="button is-primary" @click="toggleAddingFile"><strong>{{ $t('FilesData.NewFile') }}</strong></button>
                  </div>
                </div>
              </div>


              <div class="content-body">
                <div class="field is-grouped is-grouped-right">
                  <!-- Button to save modifications in specialty data -->
                  <p class="control"
                    v-if="getEditingSpecialty">
                    <button type="submit" class="button is-primary">{{ $t('General.Save') }}</button>
                  </p>
                  <!-- Button to cancel modifications in specialty data -->
                  <p class="control"
                    v-if="getEditingSpecialty">
                    <a @click="cancelEditing" class="button is-light">
                      {{ $t('General.Cancel') }}
                    </a>
                  </p>
                  <!-- Button to modify specialty data -->
                  <p class="control"
                    v-if="!getEditingSpecialty && !getSpecialtyDetailing">
                    <a @click="iniSpecialtyEditing" class="button is-primary">
                      {{ $t('General.ModifyData') }}
                    </a>
                  </p>
                  <!-- Button to leave specialty data screen-->
                  <p class="control" v-if="getSpecialtyDetailing">
                    <a @click="endSpecialtyDetailing" class="button is-primary">
                      {{ $t('General.Back') }}
                    </a>
                  </p>
                </div>
              </div>

              <!-- Form to add file-->
              <div class="content-body">
                <form @submit.prevent="addFileMeth" v-if="addingFile">
                  <div class="header">
                    <h5 class="title is-5 mt-4">
                      {{ $t('FilesData.AddNewFile') }}
                    </h5>
                  </div>
                  <SpecialtyDataFileDataForm ref="refNewFileDataForm"></SpecialtyDataFileDataForm>
                  <div class="field is-grouped is-grouped-right">
                    <p class="control">
                      <button type="submit" class="button is-primary">{{ $t('General.Add') }}</button>
                    </p>
                    <p class="control">
                      <a @click="toggleAddingFile" class="button is-light">
                        {{ $t('General.Cancel') }}
                      </a>
                    </p>
                  </div>
                </form>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import Navbar from "../components/Navbar.vue";
import { Notyf } from "notyf";
import SpecialtyDataFileTableRow from "../components/SpecialtyDataFileTableRow.vue";
import SpecialtyDataFileDataForm from "../components/SpecialtyDataFileDataForm.vue";
import { useRoute } from 'vue-router';
import { changeLocale } from "@/main"; // Import the changeLocale function

const notyf = new Notyf()

export default defineComponent({
  name: "SpecialtyData",
  components: { Navbar, SpecialtyDataFileTableRow, SpecialtyDataFileDataForm},

  data() {
    return {
      componentName: "SpecialtyData",
      route: useRoute(),
      language: '',
      selectedFiles: [] as File[],
      addingFile: false,
    }
  },
  computed: {
    ...mapGetters(['getEditedSpecialtyData', 'userData', 'getEditingSpecialty', 'getSpecialtyDetailing', 'getAccessType', 
                  'getEditedSpecialtyFiles', 'getEditedSpecialtyNewFileData', 'getEditedSpecialtyFilesToDelete', 'getMngMode']),
    
  },
  methods: {
    ...mapActions(['editSpecialty', 'iniEditedSpecialty', 'iniSpecialtyEditing', 'endSpecialtyEditing', 'toggleShowingSpecialtyData',
                  'toggleSpecialtyDetailing', 'IniAccessType', 'addFileEditedSpecialty', 'deleteEditedSpecialtyFile', 'createEditedSpecialtyFile',
                  'iniEditedSpecialtyFiles', 'resetSpecialtyFiles']),

    
    handleFileUpload(event: Event) {
      const inputElement = event.target as HTMLInputElement;
      if (inputElement && inputElement.files) {
        const files = Array.from(inputElement.files) as File[];
        // Reset selectedFiles array
        this.selectedFiles = [];
        // Add each selected file to selectedFiles array
        for (const file of files) {
          this.selectedFiles.push(file);
        }
      }
    },
    
    toggleAddingFile()
    {
      this.addingFile = !this.addingFile
    },

    async addFileMeth()
    {
      console.log(this.getEditedSpecialtyFiles)

      // Calculate the total size of existing files
      const existingFileSize = this.getEditedSpecialtyFiles.reduce((total: number, fileData: any) =>
      {
        return total + (fileData.file_size ? parseInt(fileData.file_size, 10) : 0); // Accumulate size of each existing file
      }, 0);

      // Get the new file from getEditedSpecialtyNewFileData
      const newFileData = this.getEditedSpecialtyNewFileData; // Access new specialty file data
      const newFile: File | null = newFileData.file; // Get the new file
      const newFileSize: number = newFile ? newFile.size : 0; // Size of the new file, default to 0 if not present

      // Calculate the total size including the new file
      const totalFileSize: number = existingFileSize + newFileSize;

      // Determine the maximum allowed file size
      const maxSize: number = 1000 * 1024 * 1024; // 1 GB

      // Check if total size exceeds the limit
      if (totalFileSize > maxSize) {
        notyf.error(this.$t('FilesData.MaxFilesSizeExceededMessage'));
        return; // Exit the method if size exceeds the limit
      }

      // Proceed with adding the file
      this.addFileEditedSpecialty(newFileData)
      console.log(this.getEditedSpecialtyFiles)
      this.toggleAddingFile();
      
      // Cleans the form with file data using method in child component
      (this.$refs.refNewFileDataForm as any).clearFormFile();
      notyf.success(this.$t('FilesData.NotyfNewFileAdded'))
    },
    
    async editSpecialtyMeth()
    {
      console.log("editSpecialtyMeth", this.getEditedSpecialtyData)
      
      // verify if all fields are filled
      if (!this.getEditedSpecialtyData.name)
      {
        notyf.error(this.$t('SpecialtyData.NotyfFillAllFields'))
        return;
      }

      try
      {
        const editedSpecialtyId: number = await this.editSpecialty(this.getEditedSpecialtyData)
        
        console.log(editedSpecialtyId)

        //Delete removed files
        for (var fileId of this.getEditedSpecialtyFilesToDelete)
        {
          await this.deleteEditedSpecialtyFile(fileId);
        }
        //Create new files
        for (var editedFileData of this.getEditedSpecialtyFiles)
        {
          // if there is a new file added to the specialty
          if (editedFileData.file_id == 0) {
            const newFileFormData = new FormData();
            newFileFormData.append
            (
              'file_data',
              JSON.stringify
              (
              {
                specialty_id: this.getEditedSpecialtyData.specialty_id,
                file_description: editedFileData.file_description,
              }
              )
            );
            // Append file
            newFileFormData.append('files[]', editedFileData.file);
            //create new added file
            await this.createEditedSpecialtyFile(newFileFormData)
        
          }
        }

        this.endSpecialtyEditing()
        notyf.success(this.$t('SpecialtyData.NotyfDataEdited'))
        this.initializeEditedSpecialty()
      }
      catch (e)
      {
        notyf.error(this.$t('SpecialtyData.NotyfErrorUpdatingData'))
      }




    },

    cancelEditing() {
      this.endSpecialtyEditing()
      this.clearFormSpecialty()
      this.initializeEditedSpecialty()
    },

    async clearFormSpecialty() {
      // This function seems not to be doing anything from where it is called
      // redundant ?
      const resultIniSpecialty = await this.iniEditedSpecialty(this.getEditedSpecialtyData.specialty_id);
    },


    async initializeEditedSpecialty() {

      console.log("initializeEditedSpecialty", this.getEditedSpecialtyData.specialty_id)
      console.log(this.getSpecialtyDetailing);
      
      this.resetSpecialtyFiles();
      
      if (!this.getSpecialtyDetailing) {
        console.log(this.getEditedSpecialtyData.specialty_id);
        const resultIniSpecialty = await this.iniEditedSpecialty(this.getEditedSpecialtyData.specialty_id);
        console.log(resultIniSpecialty);
      }
      const resultIniFiles = await this.iniEditedSpecialtyFiles(this.getEditedSpecialtyData.specialty_id);
      console.log(resultIniFiles);
      console.log(this.getEditedSpecialtyFiles);
      console.log(this.getEditedSpecialtyData);
    },

    endSpecialtyDetailing() {
      this.toggleShowingSpecialtyData(true);
      this.toggleSpecialtyDetailing(true);
      this.clearFormSpecialty();
      this.$router.go(-1);
    },

    
  },
  beforeMount() {
    this.language = this.route.query.lang as string;
    const accessType = this.route.query.access as string;

    if (this.language)
    {
      try
      {
        changeLocale(this.language);
      }
      catch (error)
      {
        console.error('Failed to change language:', error);
      }
    }
    else
    {
      console.log("lang does not exist");
    }
    if (accessType)
    {
      try
      {
        this.IniAccessType(accessType);
      }
      catch (error)
      {
        console.error('Failed to set access type:', error);
      }
    }
    else
    {
      console.log("access type does not exist");
    }
    this.initializeEditedSpecialty();
  },

})
</script>

<style scoped>
.content-body {
  margin-top: 10px;
}

.content-body {
  margin-top: 10px;
}

.table-container {
  overflow-x: auto;
}

table {
  border-collapse: separate;
  min-width: 800px;
}

.sticky-column {
  position: sticky;
  max-width: 150px; /* Ensure it doesn't expand beyond this width */
  left: 0;
  background: #fff; /* Match table background */
  z-index: 2;
  border-right: 1px solid #ddd; 
  border-left: 1px solid #ddd;
  will-change: left; /* Optimize performance */
} 

</style>